import React from 'react'

import SubscriptionTagIcon from 'Pods/Shared/Icons/SubscriptionTagIcon'

function ModelCardSubEligibleTag() {
  return (
    <div className="card-3d-model__sub-eligible-tag card-3d-model__sub-eligible-tag--visible">
      <SubscriptionTagIcon
        className="card-3d-model__sub-eligible-tag-icon"
        width="16"
        height="16"
      />
      <span className="card-3d-model__sub-eligible-tag-text">
        FREE IN SUBSCRIPTION
      </span>
    </div>
  )
}

export default ModelCardSubEligibleTag
